import {animated} from 'react-spring';

import styled, {css} from 'styled-components';

import {mixins} from '../styles';

type TOpenProps = {
  open: boolean;
};

type TLabelProps = TOpenProps & {
  isTopAlign?: boolean;
  disabled?: boolean;
};

const getLabelDisabledStyle = ({disabled, theme: {branding}}: TTheme & TLabelProps) => {
  if (disabled) {
    return mixins.disabled;
  }

  return css`
    color: ${branding.content.primary};
    cursor: pointer;
  `;
};

export const Label = styled.div<TLabelProps>`
  ${mixins.f4}
  width: 100%;
  cursor: pointer;
  ${getLabelDisabledStyle}
  ${({isTopAlign, theme: {animation}}) => css`
    ${mixins.flexAlign('space-between', isTopAlign ? 'flex-start' : 'center')}
    transition: color ${animation.duration}ms linear;
  `}
`;

export const ArrowIcon = styled.svg<TOpenProps>`
  ${mixins.wh('24px')}
  flex-shrink: 0;
  ${({open, theme}) => css`
    transform: ${open ? 'rotate(180deg)' : 'none'};
    transition: transform ${theme.animation.duration}ms linear;
  `}
`;

export const AnimatedChildren = styled(animated.div)`
  transform-origin: top;
`;
